import axios, { AxiosRequestConfig } from 'axios';
import U from './Utils';
import CSharpUtils from './CSharpUtils';

/** Svar fra GET {WEBAPI_PATH}/product/freight */
export interface ProductFreightDto {
  found: boolean;
  message?: string;
  length?: number | null;
  width?: number | null;
  height?: number | null;
  netWeight?: number | null;
  grossWeight?: number | null;
  countryOfOrigin?: string | null;
  unNumber?: string | null;
  dangerClass?: string | null;
  hsNumber?: string | null;
}

/** Payload til PUT {WEBAPI_PATH}/product/freight */
export interface UpdateProductFreightPayload {
  edbNumber: number;
  length: number | null;
  width: number | null;
  height: number | null;
  netWeight: number | null;
  grossWeight: number | null;
  countryOfOrigin: string | null;
  unNumber: string | null;
  dangerClass: string | null;
  hsNumber: string | null;
}

export interface UpdateProductFreightResult {
  updated: boolean;
  message: string;
}

export const getProductFreight = (edbNumber: number) => {
  const config = {
    method: 'get',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/product/freight?edbNumber=${edbNumber}`,
    timeout: 20000,
    headers: {
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
  } as AxiosRequestConfig;
  return axios.request<ProductFreightDto>(config);
};

export const updateProductFreight = (payload: UpdateProductFreightPayload) => {
  const config = {
    method: 'put',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/product/freight`,
    timeout: 20000,
    headers: {
      'content-type': 'application/json',
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: payload,
    responseType: 'json',
  } as AxiosRequestConfig;
  return axios.request<UpdateProductFreightResult>(config);
};

// ─── Bulk-opplasting (US 26) ────────────────────────────────────────────────

/** Én rad i forhåndsvisningen fra POST {WEBAPI_PATH}/product/freight/bulk/preview */
export interface FreightBulkPreviewRow {
  lineNumber: number;
  edbNumber?: number | null;
  status: string; // 'Endres' | 'Uendret' | 'Ikke funnet' | 'Feil'
  message?: string | null;
  changedFields: string[];
  length?: number | null;
  width?: number | null;
  height?: number | null;
  netWeight?: number | null;
  grossWeight?: number | null;
  countryOfOrigin?: string | null;
  unNumber?: string | null;
  dangerClass?: string | null;
  hsNumber?: string | null;
}

export interface FreightBulkPreviewResponse {
  success: boolean;
  message?: string | null;
  totalRows: number;
  willChange: number;
  unchanged: number;
  notFound: number;
  errorCount: number;
  rows: FreightBulkPreviewRow[];
  errors: string[];
}

/** Én feilet rad i importrapporten (EDB-nummer der cellen lot seg lese). */
export interface FreightBulkFailedRow {
  lineNumber: number;
  edbNumber?: number | null;
  reason: string;
}

export interface FreightBulkProcessResponse {
  success: boolean;
  message?: string | null;
  totalRows: number;
  updated: number;
  unchanged: number;
  notFound: number;
  errors: number;
  failedRows: FreightBulkFailedRow[];
  errorMessages: string[];
  emailSent: boolean;
}

export const previewProductFreightBulk = (formData: FormData) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/product/freight/bulk/preview`,
    timeout: 120000,
    headers: {
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: formData,
    responseType: 'json',
  } as AxiosRequestConfig;
  return axios.request<FreightBulkPreviewResponse>(config);
};

export const processProductFreightBulk = (formData: FormData) => {
  const config = {
    method: 'post',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/product/freight/bulk/process`,
    timeout: 600000, // opptil 10 000 rader — gi prosesseringen god tid
    headers: {
      Accept: 'application/json;charset=utf-8',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: formData,
    responseType: 'json',
  } as AxiosRequestConfig;
  return axios.request<FreightBulkProcessResponse>(config);
};

export const downloadProductFreightBulkTemplate = () => {
  const config = {
    method: 'get',
    baseURL: `${U.URL_ADDRESS}${U.WEBAPI_PATH}/product/freight/bulk/template`,
    timeout: 20000,
    headers: {
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'blob',
  } as AxiosRequestConfig;
  return axios.request<Blob>(config);
};
